import { useQuery } from 'react-query';
import { isObject } from 'lodash';

import { GetManyResult, GetOneResult, IRequestPayload } from 'coreOld/types';
import { partsService } from 'partsOld/services';
import { IPart, IPartAutocomplete } from 'partsOld/types';

export const useGetPart = (
  requestPayload?: IRequestPayload,
  enabled = false
): GetOneResult<IPart> => {
  const { data, isLoading, isError, refetch } = useQuery(
    ['searchedPart', requestPayload],
    ({ signal }) => partsService.getOne(requestPayload, signal),
    {
      enabled,
    }
  );

  const part = isObject(data?.record) ? data?.record : null;

  return {
    record: part ?? null,
    isLoading,
    isError,
    refetch,
  };
};

export const useGetPartsAutocomplete = (
  requestPayload?: IRequestPayload
): GetManyResult<IPartAutocomplete> => {
  const { data, isError, isLoading, refetch } = useQuery(
    ['autocompleteParts', requestPayload],
    ({ signal }) => partsService.getManyAutocomplete(requestPayload, signal),
    {
      keepPreviousData: true,
    }
  );

  return {
    records: data?.records ?? [],
    count: data?.count,
    isError,
    isLoading,
    refetch,
  };
};
